import React from "react";
import styled from "@emotion/styled";

const Wrapper = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const VoidPointsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const VoidPoints = styled.div`
  font-family: "Press Start 2P", monospace;
  font-size: 12px;
  white-space: nowrap;
  margin-top: 6px;
`;

const LifeSupportWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: -20px;
`;

const LifeSupportPercentWrapper = styled.div`
  margin-left: 12px;
  margin-top: 6px;
  width: 75%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
`;

const LifeSupportPercent = styled.div`
  font-family: "Press Start 2P", monospace;
  font-size: 8px;
  white-space: nowrap;
`;

const LifeSupport = styled.div`
  font-family: "VT323", monospace;
  font-size: 24px;
  white-space: nowrap;
`;

const HolosWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Holos = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;

const Title = styled.div`
  font-family: "Press Start 2P", monospace;
  font-size: 10px;
  white-space: nowrap;
`;

const Text = styled.div`
  font-family: "VT323", monospace;
  font-size: 16px;
  margin-left: 12px;
  flex-shrink: 1;
  text-align: start;
  margin-top: -4px;
`;

const Extras = ({ character }) => {
  return (
    <Wrapper>
      <HolosWrapper>
        <Holos>
          <Title>HOLOS</Title>
          <Text>{character.holos}</Text>
        </Holos>
        <Holos>
          <Title>ITEM SLOTS</Title>
          <Text>{character.itemSlots}</Text>
        </Holos>
      </HolosWrapper>
      <VoidPointsWrapper>
        <Title>VOID POINTS</Title>
        <VoidPoints>{"O O O O"}</VoidPoints>
      </VoidPointsWrapper>
      <LifeSupportWrapper>
        <Title>LIFE SUPPORT</Title>
        <LifeSupportPercentWrapper>
          <LifeSupportPercent>0%</LifeSupportPercent>
          <LifeSupportPercent>100%</LifeSupportPercent>
        </LifeSupportPercentWrapper>
        <LifeSupport>{`|  |  |  |  |  |  |  |`}</LifeSupport>
        <LifeSupport>{`|  |  |  |  |  |  |  |`}</LifeSupport>
        <LifeSupport>{`|  |  |  |  |  |  |  |`}</LifeSupport>
      </LifeSupportWrapper>
    </Wrapper>
  );
};

export default Extras;
